import React, {
  useState,
  useContext,
  useEffect
} from 'react';

import
  PropTypes
from 'prop-types';

import *
  as VettingHelpers
from 'src/Components/CreditVetting/creditVettingUtils';

import 
  VettingDropDown
from 'src/Components/Common/VettingDropDown/VettingDropDown';

import
  VettingInput
from 'src/Components/Common/VettingInput/VettingInput';

import
  KeyValueDataComponent
from 'src/Components/CreditVetting/KeyValueDataComponent/KeyValueDataComponent';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  FormFieldLabel
} from 'src/StyledComponents';

import {
  checkInputValidity,
  checkAlternativeInputValidity,
  getKeyValueData,
  createArray,
  registerEnterEvent
} from 'src/Utility/utility';

import './VettingContactDetails.css';

const validateComponent = (component, key) => {

  if (key === 'altContactPerson' || key == 'altCellPhoneNo' || key === 'secondaryEmail') {

    component.isValid = checkAlternativeInputValidity(
      component.value,
      component.validations
    );
  } else {
    component.isValid = checkInputValidity(
      component.value,
      component.validations
    );
  }

  component.isTouched = true;

  return component;
}

const checkFormValidity = (formCompsCopy = {}) => {

  const isAltContactValid = !(formCompsCopy.altContactPerson.isValid ^ formCompsCopy.altCellPhoneNo.isValid)
    && !(!!formCompsCopy.altContactPerson.value ^ !!formCompsCopy.altCellPhoneNo.value);

  return !Object.keys(formCompsCopy).some(e => !formCompsCopy[e].isValid)
    && isAltContactValid;
}

const VettingContactDetails = (props) => {

  const context = useContext(SalesContext);
  const contactDetailsData = context.vettingCreditDetails.contactDetails;

  const [formData, setFormData] = useState({
    formComponents: VettingHelpers.createFormComponentsConfig(contactDetailsData),
    isFormValid: false,
    isFormValidated: false,
  });

  // Create array
  const formCompArray = createArray(formData.formComponents);
  registerEnterEvent();

  useEffect(() => {
    if (formData.isFormValidated) return;

    const formCompsCopy = { ...formData.formComponents };

    for (const key in formCompsCopy) {

      if (
        !formCompsCopy[key]
        || Object.keys(formCompsCopy[key]).length === 0
        || (
          !props.isEditModeOn
          && (!formCompsCopy[key].isTouched && !formCompsCopy[key].validations.isPeerTouched)
        )
      )
        continue;

      formCompsCopy[key] = validateComponent(formCompsCopy[key], key);

      const peerInputs = formCompsCopy[key].validations?.peerInputs || [];

      if (
        Array.isArray(peerInputs)
        && peerInputs.length > 0
      ) {
        if (formCompsCopy[key].isValid && !formCompsCopy[key].value) {
          const isValid = !peerInputs.some(input => !!formCompsCopy[input].value);

          formCompsCopy[key].isValid = isValid;
        }

        for (let peerFieldKey of peerInputs) {
          formCompsCopy[peerFieldKey].validations.isPeerTouched = true;
        }
      }
    }

    const isFormValid = checkFormValidity(formCompsCopy);

    setFormData({
      formComponents: formCompsCopy,
      isFormValid: isFormValid,
      isFormValidated: true,
    });

    props.toggleNext(isFormValid);
  }, [props, formData]);

  const formComponentChangeHandler = (event, inputIdentifier) => {
    const changedComponent = { ...formData.formComponents[inputIdentifier] };

    if (inputIdentifier === 'secondaryEmail' || inputIdentifier === 'altCellPhoneNo' || inputIdentifier === 'cellPhoneNo' || inputIdentifier === 'email') {
      changedComponent.value = event.trim();
    }
    else {
      changedComponent.value = event;
    }
    const newFormComps = {
      ...formData.formComponents,
      [inputIdentifier]: validateComponent(changedComponent, inputIdentifier)
    }

    const isFormValid = checkFormValidity(newFormComps);

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid,
      isFormValidated: false,
    });

    props.toggleNext(isFormValid);
  };

  const saveDetails = () => {
    const keyValueData = getKeyValueData(formData.formComponents);
    context.setVettingDetails('contactDetails', keyValueData);

    const {
      secondaryEmail,
      email,
      altContactPerson,
      altCellPhoneNo,
      cellPhoneNo
    } = keyValueData;

    keyValueData.secondaryEmail.value = secondaryEmail.value || email.value;
    keyValueData.altContactPerson.value = altContactPerson.value || props.name;
    keyValueData.altCellPhoneNo.value = altCellPhoneNo.value || cellPhoneNo.value;
    props.onNextClick(keyValueData);
  };
  

  return (

    <React.Fragment>

      <div className="vetting-main-section-wrapper">

        { contactDetailsData && !props.isEditModeOn

          ? <KeyValueDataComponent data={contactDetailsData} />

          : <React.Fragment>

              <div className="vetting-pd-wrapper">

                { formCompArray.map(item => {

                  return (

                    <div 
                      className={`input-field-wrapper-${item.config.width}`} 
                      key={item.key}>

                      <FormFieldLabel
                        hide={item?.config?.hideLabel ? 1 : 0}>

                        {item.config.name}
                      </FormFieldLabel>

                      { item.config.type === 'input'

                        ? <VettingInput
                            {...item.config}
                            updateValue={formComponentChangeHandler}
                            inputIdentifier={item.key}/>

                        : null
                      }

                      { item.config.type === 'dropDown'
                      
                        ? <VettingDropDown
                            selectedValue={item.config.value}
                            placeholder={item.config.config.placeholder}
                            options={item.config.options}
                            updateSelectedOption={formComponentChangeHandler}
                            inputIdentifier={item.key}/>

                        : null
                      }
                    </div>
                  )
                })
                }
              </div>

              { props.showBody
                ? <div className="vetting-next-wrapper">

                    <button
                      className={`vetting-section-next-button ${props.enableNext ? 'next-enabled' : ''}`}
                      onClick={() => saveDetails()}
                      disabled={props.enableNext ? '' : 'disabled'}>

                      Next
                    </button>
                  </div>

                : null
              }
            </React.Fragment>
        }
      </div>

    </React.Fragment>
  )
}

VettingContactDetails.propTypes = {
  enableNext: PropTypes.bool,
  isEditModeOn: PropTypes.bool,
  onNextClick: PropTypes.func,
  showBody: PropTypes.bool,
  toggleNext: PropTypes.func,
  name: PropTypes.string
}

export default VettingContactDetails;